
import { useState, useEffect } from "react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export function useAuthentication(fetchData: () => void) {
  const { toast } = useToast();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  // Check if user is authenticated
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error("Error checking auth:", error);
          toast({
            title: "Authentication error",
            description: "There was a problem verifying your login status.",
            variant: "destructive",
          });
          setIsAuthenticated(false);
          return;
        }

        setIsAuthenticated(!!data.session);
        
        if (!data.session) {
          toast({
            title: "Authentication required",
            description: "You need to be logged in to manage sermon plans.",
            variant: "destructive",
          });
        } else {
          // If authenticated, refresh data
          fetchData();
        }
      } catch (error) {
        console.error("Unexpected error during auth check:", error);
        setIsAuthenticated(false);
      }
    };
    
    checkAuth();
  }, [toast, fetchData]);

  return { isAuthenticated };
}
